import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IconTextProps {
	icon: IconDefinition;
	text?: string;
	className?: string;
	iconClassName?: string;
}

export function IconText({ icon, text, className, iconClassName }: IconTextProps) {
	return (
		<span className={`flex items-center ${className}`}>
			<span>
				<FontAwesomeIcon icon={icon} className={`size-5 ${iconClassName}`} />
			</span>
			{text}
		</span>
	);
}
